import _ from 'lodash'
import * as types from '../../types'

export default {
  state: {
    successModal: {
      show: false,
      content: ''
    },
    alertModal: {
      show: false,
      content: ''
    }
  },
  getters: {
    [types.GET_SUCCESS_MESSAGE]: state => state.successModal,
    [types.GET_FAIL_MESSAGE]: state => state.alertModal
  },
  actions: {
    [types.SET_SUCCESS_MESSAGE] ({commit, state}, params) {
      commit(types.SET_SUCCESS_MESSAGE_STATE, {
        show: params.show,
        content: params.content
      })
      if (params.show === true) {
        _.delay(() => {
          commit(types.SET_SUCCESS_MESSAGE_STATE, {
            show: false,
            content: _.isEmpty(params.content) ? state.successModal.content : params.content
          })
        }, 3000)
      }
    },
    [types.SET_FAIL_MESSAGE] ({commit, state}, params) {
      commit(types.SET_FAIL_MESSAGE_STATE, {
        show: params.show,
        content: params.content
      })
      if (params.show === true) {
        _.delay(() => {
          commit(types.SET_FAIL_MESSAGE_STATE, {
            show: false,
            content: _.isEmpty(params.content) ? state.successModal.content : params.content
          })
        }, 3000)
      }
    }
  },
  mutations: {
    [types.SET_SUCCESS_MESSAGE_STATE] (state, data) {
      state.successModal = data
    },
    [types.SET_FAIL_MESSAGE_STATE] (state, data) {
      state.alertModal = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/common/modal.js